module.exports = "/_next/static/images/UnlockYourFullPotential@2x-42f1224752ad578b18500e3f6f048d68.png";